module.exports = __webpack_public_path__ + "static/media/Fast Food Double Burger.dbcd4c2f.svg";